import { AssessmentDocument, ConsentForm, EditorVersion, isConsentForm, WithId } from '@hb/shared'
import { useCallback } from 'react'
import { DefaultModalProps } from '../../Modals/DefaultModal'
import { EditorModalContainer } from '../../RichText/EditorModalContainer'
import { EditorSize } from '../../RichText/hooks'
import { ReadOnlyEditor } from '../../RichText/TextEditor'
import { ReadOnlyEditorProps } from '../../RichText/types'
import { ElectronicConsentWrapper } from '../../Users/Profile/ConsentForms/ElectronicConsent/ElectronicConsentModal'
import { ConsentFormPdfView } from '../ExternalPdf/ExternalPdfView'
import { DocumentViewHeader } from './Header'

export const DocumentViewModal = ({
  ...props
}: Omit<ReadOnlyEditorProps, 'width' | 'baseZoom' | 'height'> &
  Omit<DefaultModalProps, 'render'> & {
    adminView?: boolean
    version: EditorVersion
    document: WithId<AssessmentDocument> | WithId<ConsentForm>
  }) => {
  const {
    decorators,
    value,
    withDownload,
    document,
    version,
    onFormSubmit,
    adminView,
    ...modalProps
  } = props

  const { onClose } = modalProps
  const getBody = useCallback(
    (editorSize: EditorSize) => {
      const body =
        document && isConsentForm(document) && document.isExternalPdf ? (
          <ConsentFormPdfView
            consentForm={document}
            editorSize={editorSize}
            withDownload={withDownload}
            onFormSubmit={onFormSubmit}>
            <DocumentViewHeader adminView={adminView} document={document} onBack={onClose} />
          </ConsentFormPdfView>
        ) : (
          <ReadOnlyEditor
            version={version}
            {...editorSize}
            decorators={decorators}
            onFormSubmit={onFormSubmit}
            document={document}
            withDownload={withDownload}
            value={value}>
            <DocumentViewHeader adminView={adminView} document={document} onBack={onClose} />
          </ReadOnlyEditor>
        )
      return (
        <ElectronicConsentWrapper
          document={document}
          containerHeight={editorSize.height}
          containerWidth={editorSize.width}
          onCloseDocument={onClose}>
          {body}
        </ElectronicConsentWrapper>
      )
    },
    [version, onFormSubmit, withDownload, value, decorators, onClose, adminView, document],
  )

  return (
    <>
      <EditorModalContainer
        {...modalProps}
        closeDisabled
        render={editorSize => getBody(editorSize)}
      />
    </>
  )
}
